<template>
    <div class="report-score-acc-aha"
         v-if="$store.state.patientParticipant.latestScoreDefs">

        <div class="acc-risk-value">
            {{ risk }}
        </div>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'
    import * as _ from 'lodash'

    /**
     * Displays the value of the ACC_AHA_SCORE score
     */
    export default Vue.extend({
        computed: {
            scoreDef() {
                return this.$store.state.patientParticipant.latestScoreDefs['ACC_AHA_SCORE']
            },
            risk() {
                if (!this.scoreDef) {
                    return null
                } else {
                    const as = this.scoreDef.score.score

                    if (as !== null) {
                        return Number(100 * as).toFixed(0) + '%'
                    } else {
                        return this.$i18n.gt('MESSAGE_REPORT_ACC_AHA_NOT_APPLICABLE')
                    }
                }
            }
        }
    })
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
    .report-score-acc-aha {
        .acc-risk-value {
            font-weight: bold;
            min-width: 100px;
            padding: .25rem .5rem;
            margin: .5em auto;
            border-radius: 4px;
            background: #f0f0f0;
            text-align: center;
            font-size: 16px;
        }
    }
</style>

